import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './css/popup.css';
import { Translator, resources } from './Translator';
import QRCode from 'qrcode.react';
import { CommonUtils } from './CommonUtils';

const translator = new Translator(resources);

const MapSharePopup = ({ onClose,currentProject }) => {
    const t = (key) => translator.t(key);
    const [currentUrl, setCurrentUrl] = useState('');
    const [isCopied, setIsCopied] = useState(false);
    const [showEmbed, setShowEmbed] = useState(false);
    const [isEmbedCopied, setIsEmbedCopied] = useState(false);
    const [isQrFullscreen, setIsQrFullscreen] = useState(false);
    const [qrFullSize, setQrFullSize] = useState(320);

    useEffect(() => {
		const url = window.location.href;
		const replacedUrl = url.replace('http://localhost:3000/', 'https://collabomap.com/');
		setCurrentUrl(replacedUrl);
    }, []);

    // 全画面QRは画面の短辺に追従させ、Escでも閉じられるようにする
    useEffect(() => {
        if (!isQrFullscreen) return;

        const updateSize = () => {
            const shortSide = Math.min(window.innerWidth, window.innerHeight);
            setQrFullSize(Math.max(160, Math.floor(shortSide * 0.8)));
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setIsQrFullscreen(false);
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('resize', updateSize);
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isQrFullscreen]);

    const handleCopyUrl = () => {
        if(!currentProject) return;
        let hashtags = "";
        if(currentProject.tags && currentProject.tags.length > 0) hashtags = currentProject.tags.map(word => `#${word}`).join(' ');
        let copyText = `[${currentProject.title} : ${currentProject.memo} ${hashtags}]\n${currentUrl}`;

        navigator.clipboard.writeText(copyText).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        });
    };

    const embedCode = `<iframe src="${currentUrl}" width="100%" height="480" allowfullscreen></iframe>`;

    const handleCopyEmbed = () => {
        navigator.clipboard.writeText(embedCode).then(() => {
            setIsEmbedCopied(true);
            setTimeout(() => setIsEmbedCopied(false), 2000);
        });
    };

    return (
        <div className="popup">
            <span className="close_button" onClick={onClose}>&times;</span>
            <div className="popup-inner">
                <h2>{t('Share Map')}</h2>
                <div className="url-container">
                    <input type="text" value={currentUrl} readOnly />
                    <button className='button_b' onClick={handleCopyUrl}>
                        {isCopied ? t('Copied!') : t('Copy URL')}
                    </button>
                </div>
                <div className="qr-code-container" style={{
                    backgroundColor: 'white',
                    padding: '20px',
					borderRadius:'10px',
                    display: 'inline-block',
                    margin: '20px 0',
                    position: 'relative'
                }}>
                    <QRCode value={currentUrl} size={160} />
                    <button
                        onClick={() => setIsQrFullscreen(true)}
                        title={t('QR Fullscreen')}
                        aria-label={t('QR Fullscreen')}
                        style={{
                            position: 'absolute',
                            /* QRコード本体に被らないよう白枠の右下角にはみ出させる */
                            right: '-14px',
                            bottom: '-14px',
                            width: '34px',
                            height: '34px',
                            margin: 0,
                            padding: 0,
                            border: 'none',
                            borderRadius: '50%',
                            backgroundColor: '#39c',
                            color: 'white',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.4)'
                        }}
                    >
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
                    </button>
                </div><p></p>
                <button className='button_b' onClick={() => setShowEmbed(v => !v)}>
                    {t('Embed on your site')}
                </button>
                {showEmbed && (
                    <div style={{ marginTop: '12px' }}>
                        <p style={{ margin: '0 0 6px' }}>{t('Embed Code')}</p>
                        <div className="url-container">
                            <input type="text" value={embedCode} readOnly />
                            <button className='button_b' onClick={handleCopyEmbed}>
                                {isEmbedCopied ? t('Copied!') : t('Copy Code')}
                            </button>
                        </div>
                    </div>
                )}
                <p></p>
                <button className='button_y' onClick={onClose}>{t('Close')}</button>
            </div>
            {/* .popup が transform を持つため、そのままの position:fixed はビューポート基準にならない。body へポータルする */}
            {isQrFullscreen && ReactDOM.createPortal(
                <div
                    onClick={() => setIsQrFullscreen(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10001
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            padding: '16px',
                            borderRadius: '12px',
                            lineHeight: 0
                        }}
                    >
                        <QRCode value={currentUrl} size={qrFullSize} />
                    </div>
                    <button
                        onClick={() => setIsQrFullscreen(false)}
                        title={t('Close')}
                        aria-label={t('Close')}
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '16px',
                            margin: 0,
                            padding: 0,
                            fontSize: '32px',
                            lineHeight: 1,
                            color: 'white',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >&times;</button>
                </div>,
                document.body
            )}
        </div>
    );
};

export default MapSharePopup;